import type { InfiniteData } from '@tanstack/react-query';
import type { Transaction } from '@asia/shared';
import type { TxPage } from './tron';

/** Keep just-broadcast rows that TronGrid has not indexed yet. */
const OPTIMISTIC_TX_MS = 2 * 60_000;

/**
 * Merge a fresh server page-0 into the infinite txs cache without dropping
 * optimistic sends that are still absent from TronGrid.
 */
export function mergeTxsPage0(
  old: InfiniteData<TxPage> | undefined,
  serverTxs: Transaction[],
  nextBefore: number | null,
): InfiniteData<TxPage> {
  const serverIds = new Set(serverTxs.map((t) => t.id));
  const now = Date.now();
  const pendingOptimistic =
    old?.pages[0]?.txs.filter((t) => {
      if (serverIds.has(t.id)) return false;
      const age = now - Date.parse(t.date);
      return Number.isFinite(age) && age >= 0 && age < OPTIMISTIC_TX_MS;
    }) ?? [];
  const page0: TxPage = { txs: [...pendingOptimistic, ...serverTxs], nextBefore };
  if (!old || old.pages.length === 0) {
    return { pages: [page0], pageParams: [undefined] };
  }
  const pages = old.pages.slice();
  pages[0] = page0;
  return { ...old, pages };
}
